<template>
	<div id="section-shipment">
		<template
			v-if="$_deliverySelect_deliveryAvailable"
		>
			<hr>

			<div
				class="flex"
			>
				<h4>Data di consegna</h4>
			</div>

			<div>
				{{ $t("components.checkout.bill.label_before_delivery_day") }}
				{{ $_dates_readableDate(orderStore.order.date.delivery) }}
			</div>

		</template>
	</div>
</template>

<script>

import { deliverySelect } from '../../mixins/delivery'
import { dates } from '../../mixins/dates'

import InfoTooltip from '../Parts/InfoTooltip'
import { stepStore } from '../../store/stepStore'
import { shipmentZonesStore } from '../../store/shipmentZonesStore'
import { subscriptionStore } from '../../store/subscriptionStore'
import { orderStore } from '../../store/orderStore'

export default {
	data () {
		return {
			orderStore: orderStore.state,
			showChangeShipment: false,
			shipmentZonesStore: shipmentZonesStore.state,
			subscriptionStore: subscriptionStore.state
		}
	},

	components: {
		InfoTooltip
	},

	mixins: [
		deliverySelect,
		dates
	],

	computed: {
		deliveryDate () {
			if (!this.$_deliverySelect_selectedDelivery) return
			return this.$_dates_readableDate(this.$_deliverySelect_selectedDelivery.delivery_date_estimated)
		},
		selectedDeliveryZoneId () {
			if (!this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex]) return
			return this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex].zone_id
		},
		user () {
			return this.$root.user
		}
	},

	methods: {
		close () {
			this.showChangeShipment = false
		},

		open () {
			this.showChangeShipment = true
		},

		updateShipmentZone () {
			if (this.orderStore.status === 'confirmed') {
				return stepStore.updateShipmentZone()
			} else {
				return Promise.resolve()
			}
		},

		afterSelect () {
			if (!this.subscriptionStore.subscriptionParams.name && this.user) {
				subscriptionStore.updateSubscriptionParam({ param: 'name', value: this.user.firstname + ' ' + this.user.lastname })
			}

			return this.updateShipmentZone()

			.then(response => {
				this.close()
			})
		}
	}
}

</script>

<style scoped>

h3 {
	font-weight: bold;
	margin-bottom: 30px;
	text-align: left;
}

select {
	padding: 0 10px;
	border: 1.5px solid #EDEDED;
	background: #ffffff99;
	color: #575A5C;
	width: 100%;
	outline: none;
	height: 36px;
	border-radius: 4px;
}

</style>
